module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Monster-Under-table-1280.e5359352.jpg";